import React from 'react'
import './Footer.scss'

function Footer() {
  return (
    <div>
      <footer class="footer">
        <div class="footer__container">
          <div class="footer__col">
            <h3 class="footer__title">BĐS Thanh Oai</h3>
            <p class="footer__desc">
              BĐS Thanh Oai là nền tảng mua bán, cho thuê bất động sản uy tín,
              kết nối người mua và chủ đầu tư nhanh chóng, hiệu quả.
            </p>
          </div>

          <div class="footer__col">
            <h3 class="footer__title">Liên hệ</h3>
            <ul class="footer__list">
              <li>📍 Hà Nội, Việt Nam</li>
              <li>📞 0974 352 222</li>
              {/* <li>✉️ contact@anphatbds.vn</li> */}
            </ul>
          </div>

          {/* <div class="footer__col">
            <h3 class="footer__title">Liên kết nhanh</h3>
            <ul class="footer__list">
              <li><a href="#">Trang chủ</a></li>
              <li><a href="#">Dự án</a></li>
              <li><a href="#">Mua bán</a></li>
              <li><a href="#">Cho thuê</a></li>
              <li><a href="#">Tin tức</a></li>
            </ul>
          </div> */}
        </div>

        <div class="footer__bottom">
          © 2026 BĐS Thanh Oai. All rights reserved.
        </div>
      </footer>

    </div>
  )
}

export default Footer